import StructureServer from "../../server/structure";
import OutputStructure, {
  OutputStructureGroup,
  RequestStructuresByGroup,
} from "../../dtos/structure";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class StructureServiceReader extends ServiceReader {
  constructor(protected api: StructureServer) {
    super();
  }

  public async byGroup(
    group: OutputStructureGroup
  ): Promise<OutputStructure[]> {
    const raw = await this.api.get(new RequestStructuresByGroup(group));
    if (!Array.isArray(raw))
      throw new TypeError("Structure list is not an array.");

    return raw.map((value) => OutputStructure.convert(value));
  }
}

class StructureServiceCreator extends ServiceCreator {}
class StructureServiceUpdater extends ServiceUpdater {}
class StructureServiceDeleter extends ServiceDeleter {}

export default class StructureService extends Service {
  constructor() {
    super(new StructureServer());
  }

  public get read(): StructureServiceReader {
    return new StructureServiceReader(this.api as StructureServer);
  }
  public get create(): ServiceCreator {
    return new StructureServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new StructureServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new StructureServiceDeleter();
  }
}
